import React from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "../components/ui/button";
import { TrendingUp, Eye, Compass, Users, Target, Check } from "lucide-react";
import { Link } from "react-router-dom";

const Offers = () => {
  const packs = [
    {
      icon: TrendingUp,
      title: "Pack 1 — Stabilisation & Marge",
      duration: "90 jours",
      objective: "Stopper les fuites de marge (achats, pertes, mix produit (gamme 80/20)). On met en place des indicateurs simples et des actions rapides pour retrouver du contrôle et de la trésorerie.",
      color: "#6B7A3A",
    },
    {
      icon: Eye,
      title: "Pack 2 — Vitrine & Storytelling",
      duration: "90 jours",
      objective: "Augmenter le ticket moyen et valoriser tes produits signature. Travail sur la vitrine, la gamme (80/20), le discours de vente et une communication simple qui donne envie d'acheter.",
      color: "#B65C3A",
    },
    {
      icon: Compass,
      title: "Pack 3 — Croissance Continue",
      duration: "mensuel",
      objective: "Un pilotage régulier pour stabiliser la performance toute l'année. Revue des indicateurs, décisions rapides, ajustements selon la saisonnalité (Noël, Pâques, été).",
      color: "#6B7A3A",
    },
    {
      icon: Users,
      title: "Pack 4 — Première Fournée",
      duration: "reprise / installation",
      objective: "Sécuriser une reprise/installation et éviter les erreurs coûteuses du début. Audit terrain, structure de gamme, prix de départ, et accompagnement pour ajuster face au réel.",
      color: "#B65C3A",
    },
  ];

  // Schema.org Service structured data
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Consulting Services",
    "provider": {
      "@type": "Person",
      "name": "Christophe Marrama"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Annecy, Savoie, Haute-Savoie"
    }
  };

  return (
    <>
      <Helmet>
        <title>Offres conseil boulangerie pâtisserie | Diagnostic marge et accompagnement | Croissance Consulting</title>
        <meta name="description" content="Diagnostic immersion, accompagnement marge, organisation, vitrine et développement pour artisans boulangers et pâtissiers à Annecy et Savoie/Haute-Savoie." />
        <link rel="canonical" href="https://croissanceconsulting.net/offres" />
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
      </Helmet>

      <div className="min-h-screen bg-[#FBF7EF]">
        {/* Hero Section */}
        <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#4A3A2A] font-poppins mb-6">
              Mes offres de conseil en boulangerie/pâtisserie
            </h1>
          </div>
        </section>

        {/* Diagnostic Immersion */}
        <section className="py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-4xl">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#4A3A2A] font-poppins mb-4">
                Diagnostic Immersion Terrain
              </h2>
              <p className="text-lg text-[#2D2D2D]">
                Analyse terrain, rentabilité, organisation et leviers concrets d'amélioration.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-xl max-w-2xl mx-auto">
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-bold text-[#6B7A3A] mb-2">Pour qui ?</h3>
                  <p className="text-[#2D2D2D]">Artisans boulangers/pâtissiers déjà en activité</p>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-[#6B7A3A] mb-2">Durée</h3>
                  <p className="text-[#2D2D2D]">2 à 3h sur place + livrable sous 48h</p>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-[#6B7A3A] mb-2">Résultat</h3>
                  <p className="text-[#2D2D2D]">3 à 5 leviers concrets + plan d'action 7–30 jours + indicateurs simples</p>
                </div>

                <div className="bg-[#6B7A3A]/5 rounded-lg p-4">
                  <h3 className="text-lg font-bold text-[#6B7A3A] mb-2">Tarif</h3>
                  <p className="text-2xl font-bold text-[#4A3A2A]">490 € TTC</p>
                </div>

                <div>
                  <h3 className="text-lg font-bold text-[#6B7A3A] mb-2">Bénéfices</h3>
                  <p className="text-[#2D2D2D]">Clarté sur la marge, réduction des invendus, décisions prix/gamme/achats.</p>
                </div>

                <div className="pt-4">
                  <Link to="/audit-rentabilite-boulangerie">
                    <Button data-testid="discover-diagnostic-btn" className="w-full bg-[#B65C3A] hover:bg-[#9d4e2f] text-white font-medium px-8 py-4 text-lg">
                      Découvrir le Diagnostic Immersion Terrain
                    </Button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Lien interne vers page Audit détaillée */}
            <div className="mt-8 text-center">
              <p className="text-lg text-[#2D2D2D]">
                <Link to="/audit-rentabilite-boulangerie" className="text-[#B65C3A] hover:underline font-medium">
                  Voir la page détaillée : Audit rentabilité →
                </Link>
              </p>
            </div>
          </div>
        </section>

        {/* Bread Image */}
        <section className="py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_6ea0b1d1-df5f-4368-91ed-bae07cdd7ca4/artifacts/gkxgurvi_20140808_164338.jpg"
                alt="Assortiment de pains artisanaux"
                className="w-full h-[400px] object-cover"
              />
            </div>
          </div>
        </section>

        {/* Packs */}
        <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
          <div className="container mx-auto">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#4A3A2A] font-poppins text-center mb-12">
              Packs d'accompagnement
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
              {packs.map((pack, index) => {
                const Icon = pack.icon;
                return (
                  <Link to="/contact" key={index} className="block h-full">
                    <div className="bg-[#FBF7EF] rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow flex flex-col h-full">
                      <div
                        className="w-14 h-14 rounded-lg flex items-center justify-center mb-4"
                        style={{ backgroundColor: `${pack.color}15` }}
                      >
                        <Icon style={{ color: pack.color }} size={28} />
                      </div>
                      <h3 className="text-xl font-bold text-[#4A3A2A] font-poppins mb-2">
                        {pack.title}
                      </h3>
                      <p className="text-sm text-[#6B7A3A] font-medium mb-4">
                        {pack.duration}
                      </p>
                      <p className="text-[#2D2D2D] mb-6 flex-grow text-sm">
                        {pack.objective}
                      </p>
                      <div className="border-t border-[#4A3A2A]/10 pt-4 mt-auto">
                        <p className="text-base font-semibold font-poppins mb-3" style={{ color: pack.color }}>
                          Nous consulter — Devis sur demande
                        </p>
                        <Button
                          className="w-full bg-white hover:bg-[#FBF7EF] border-2 font-medium text-sm py-2"
                          style={{ 
                            borderColor: pack.color,
                            color: pack.color
                          }}
                        >
                          En savoir plus
                        </Button>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* Pastry Image */}
        <section className="py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-5xl">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_diagnostic-fournil/artifacts/2ntgk79t_20180417_163925.jpg"
                alt="Fraisier artisanal"
                className="w-full h-[350px] object-cover"
              />
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
          <div className="container mx-auto max-w-3xl text-center">
            <div className="bg-[#6B7A3A]/5 rounded-2xl p-10 shadow-xl">
              <h2 className="text-3xl sm:text-4xl font-bold text-[#4A3A2A] font-poppins mb-4">
                Quelle offre choisir ?
              </h2>
              <p className="text-lg text-[#2D2D2D] mb-8">
                Chaque situation est unique. Parlons de tes besoins pour trouver la meilleure approche.
              </p>
              <Link to="/contact">
                <Button data-testid="offers-contact-btn" className="bg-[#B65C3A] hover:bg-[#9d4e2f] text-white font-medium px-10 py-6 text-lg">
                  Proposer un échange
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Zone d'intervention */}
        <section className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-4xl">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#4A3A2A] font-poppins text-center mb-8">
              Zone d'intervention
            </h2>
            <div className="bg-[#6B7A3A]/5 rounded-2xl p-8 sm:p-10 space-y-6">
              <div className="bg-white rounded-xl p-6 shadow-md">
                <h3 className="text-xl font-semibold text-[#4A3A2A] font-poppins mb-2">
                  Gratuit
                </h3>
                <p className="text-[#2D2D2D]">
                  Rayon de 20 km autour d'Annecy (jusqu'à Aix-les-Bains, Cruseilles, La Roche sur Foron, Le Grand Bornand, Ugine…)
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <h3 className="text-xl font-semibold text-[#4A3A2A] font-poppins mb-2">
                  Forfait 50 €
                </h3>
                <p className="text-[#2D2D2D]">
                  Rayon 50 km (jusqu'à Bourg St Maurice, Chamonix, Thonon/Évian, Morzine, Genève, Oyonnax, Ambérieux en Bugey, Chambéry)
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <h3 className="text-xl font-semibold text-[#4A3A2A] font-poppins mb-2">
                  Au-delà
                </h3>
                <p className="text-[#2D2D2D]">
                  Sur devis (frais réels : train/hôtel/indemnités kilométriques)
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Offers;
